import axios from 'axios';
import { commonConfiguration } from 'io/API';
import { onRequestError } from 'io/API/errorHandling';
import { getCookie } from 'utils/cookies';


// publicatiedatum koopprijs
const getHouses = (queryParameters, contextConfiguration) => {
	let url = '/wonen';

	if (queryParameters != null && queryParameters.length > 0) {
		url += '?';

		queryParameters.forEach(({ queryParameter, value }, index) => {
			if (index > 0)
				url += '&';

			url += `${encodeURI(queryParameter)}=${encodeURI(value)}`;
		});
	}

	const token = getCookie('authToken');
	return axios.get(
		url,
		{
			...commonConfiguration,
			...contextConfiguration,
			headers: {
				Authorization: token ? `Token ${token}` : undefined,
				'X-Requested-With': 'XMLHttpRequest',
			}
		}
	).catch(onRequestError);
};

export default getHouses;
